import type {createContext} from "../context-shared";
import SWWorker from "./shared-worker?sharedworker";
import {exportConfig} from "../../utils/config";
import {IPC_VERSION} from "../../utils/constants";
import {later} from "../../utils/basic";

let worker: SharedWorker | undefined;

export async function requestValidation() {
    if (!worker) {
        throw new Error('worker not set');
    }
    worker.port.postMessage({type: 'request-validation'});
}

export async function setup(ctx: ReturnType<typeof createContext>) {
    if (typeof SharedWorker === 'undefined') {
        throw new Error('SharedWorker is not supported in this browser');
    }
    return new Promise<void>((resolve, reject) => {
        try {
            worker = new SWWorker({
                name: 'swss-shared-worker',
            });
        } catch (err) {
            reject(err);
            return;
        }
        worker.onerror = (err) => {
            reject(err);
        }
        worker.port.onmessage = (event) => {
            resolve()
            if (event.data.type === 'state-dump') {
                ctx.updateState(event.data.state);
            }
        }
        worker.port.postMessage({type: 'init', version: IPC_VERSION, config: exportConfig().toString()});
        later(5000).then(() => {reject(new Error('SharedWorker initialization timed out'))})
    })
}

export function bfCacheRestore() {
    requestValidation()
}

export function onpagehide() {

}
